/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransferResponseDto
 */
export interface TransferResponseDto {
    /**
     * Internal transfer record ID
     * @type {string}
     * @memberof TransferResponseDto
     */
    id: string;
    /**
     * Stripe transfer ID
     * @type {string}
     * @memberof TransferResponseDto
     */
    stripeTransferId: string;
    /**
     * Amount transferred in dollars
     * @type {number}
     * @memberof TransferResponseDto
     */
    amountInDollars: number;
    /**
     * Currency code
     * @type {string}
     * @memberof TransferResponseDto
     */
    currency: string;
    /**
     * Transfer status
     * @type {string}
     * @memberof TransferResponseDto
     */
    status: TransferResponseDtoStatusEnum;
    /**
     * Transfer description
     * @type {string}
     * @memberof TransferResponseDto
     */
    description: string | null;
    /**
     * Date when transfer was created
     * @type {Date}
     * @memberof TransferResponseDto
     */
    createdAt: Date;
    /**
     * Date when transfer was completed
     * @type {Date}
     * @memberof TransferResponseDto
     */
    completedAt: Date | null;
}


/**
 * @export
 */
export const TransferResponseDtoStatusEnum = {
    Pending: 'pending',
    InTransit: 'in_transit',
    Paid: 'paid',
    Failed: 'failed',
    Canceled: 'canceled',
    Reversed: 'reversed'
} as const;
export type TransferResponseDtoStatusEnum = typeof TransferResponseDtoStatusEnum[keyof typeof TransferResponseDtoStatusEnum];


/**
 * Check if a given object implements the TransferResponseDto interface.
 */
export function instanceOfTransferResponseDto(value: object): value is TransferResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('stripeTransferId' in value) || value['stripeTransferId'] === undefined) return false;
    if (!('amountInDollars' in value) || value['amountInDollars'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('completedAt' in value) || value['completedAt'] === undefined) return false;
    return true;
}

export function TransferResponseDtoFromJSON(json: any): TransferResponseDto {
    return TransferResponseDtoFromJSONTyped(json, false);
}

export function TransferResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stripeTransferId': json['stripeTransferId'],
        'amountInDollars': json['amountInDollars'],
        'currency': json['currency'],
        'status': json['status'],
        'description': json['description'],
        'createdAt': (new Date(json['createdAt'])),
        'completedAt': (json['completedAt'] == null ? null : new Date(json['completedAt'])),
    };
}

export function TransferResponseDtoToJSON(json: any): TransferResponseDto {
    return TransferResponseDtoToJSONTyped(json, false);
}

export function TransferResponseDtoToJSONTyped(value?: TransferResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'stripeTransferId': value['stripeTransferId'],
        'amountInDollars': value['amountInDollars'],
        'currency': value['currency'],
        'status': value['status'],
        'description': value['description'],
        'createdAt': ((value['createdAt']).toISOString()),
        'completedAt': (value['completedAt'] == null ? null : (value['completedAt'] as any).toISOString()),
    };
}

